import Marquee from "react-fast-marquee";

const DESTINATIONS = ["Jodhpur", "Jaisalmer", "Udaipur", "Mount Abu", "Pushkar", "Jaipur", "Ajmer", "Nakoda", "Osian", "Ranakpur"];

export default function DestinationMarquee() {
  return (
    <section aria-label="Destinations" className="bg-brand-cream text-brand-ink border-y border-brand-ink/5 py-6 md:py-8" data-testid="destination-marquee">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {DESTINATIONS.concat(DESTINATIONS).map((d, i) => (
          <span key={i} className="editorial-marquee inline-flex items-center gap-8 md:gap-14 text-4xl md:text-6xl px-6 md:px-10">
            <span className="text-brand-blue">{d}</span>
            <span className="text-brand-orange">✱</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
